"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readConfig = void 0;
function readConfig(url) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "json";
    xhr.onload = function () {
      const status = xhr.status;
      if (status === 200) {
        resolve(xhr.response);
      } else {
        reject(status);
      }
    };
    xhr.send();
  });
}
exports.readConfig = readConfig;
//# sourceMappingURL=config.js.map